export default __webpack_public_path__ + "static/5907-7011-Netzteil-6b4a513acdeab3f7432cb96c58dcae2f.jpg";